<div *ngFor="let key of getKeys()" class="validation-warning">
  <div *ngIf="inHiddenLimits(key)">
    {{'common.validation.warning' | translate:getFieldFormatted(key)}}
  </div>
</div>
